import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';

/**
 * Generated class for the CuadrillaDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cuadrilla-detalle',
  templateUrl: 'cuadrilla-detalle.html',
})
export class CuadrillaDetallePage {
  item = {id : null, Nombre : null, idEmpresa : null};
  constructor(public navCtrl: NavController, public navParams: NavParams,public alertCtrl: AlertController,public partesService : PartesService) {
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }
  }
  //Añadir Persona
  addCuadrilla(){
    this.partesService.addCuadrilla(this.item);
    this.navCtrl.pop();
  } 

  //Borrar Persona
  deleteCuadrilla(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar esta Cuadrilla?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteCuadrilla(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  } 


  ionViewDidLoad() {
    console.log('ionViewDidLoad CuadrillaDetallePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/cuadrilla-detalle/cuadrilla-detalle.ts